import { shell as constants } from "store/constants";
import { PRODUCT_KEY } from "globals/constants";
import { fetchableInitialState, reduceIsFetching } from 'store/factories/fetchable';


const initialState = {
	cayuseHeader: {
		product: PRODUCT_KEY,
		host: null,
		userId: null,
		authenticationToken: null,
		customerImage: "NONE"
	},
	content: {
		...fetchableInitialState,
		user: {},
		userAccess: {
			userGroupRoles: [],
			userAccessLevel: null,
			privileges: {},
		},
		locale: "",
	},
};

export function shell(state = initialState, action) {
	switch (action.type) {
		case constants.SET_CAYUSE_HEADER:
			return {
				...state,
				cayuseHeader: {
					...state.cayuseHeader,
					...action.payload,
				},
			};
		case constants.SHELL_IS_FETCHING: {
			return {
				...state,
				content: reduceIsFetching(state.content, action),
			};
		}
		case constants.SHELL_SET_DATA: {
			return {
				...state,
				content: {
					...state.content,
					...action.payload,
				},
			};
		}
		case constants.SHELL_SET_ERROR: {
			return {
				...state,
				content: {
					...state.content,
					error: action.payload,
				},
			};
		}
		case constants.SET_USER_PRIVILEGES: {
			return {
				...state,
				content: {
					...state.content,
					userAccess: {
						...state.content.userAccess,
						privileges: {
							...action.privileges,
						},
					},
				},
			};
		}
		case constants.RESET:
			return initialState;
		default:
			return state;
	}
}
